import { Amplitude } from 'utils';
export const logDeleteDetails = (source, payload, type) => {
    Amplitude.logEvent('Delete.Text', {
        source,
        payload,
        type,
    });
};
export const logDeleteReasonsScreen = (source) => {
    Amplitude.logEvent('Delete Reasons Screen', {
        source,
    });
};
export const logDeleteFinalScreen = (source) => {
    Amplitude.logEvent('Delete Final Screen', {
        source,
    });
};
export const logDeleteSupportScreen = (source) => {
    Amplitude.logEvent('Delete Support Screen', {
        source,
    });
};
export const logChurnedScreen = (source) => {
    Amplitude.logEvent('Churned Screen', { source });
};
export const logDeleteOfferScreen = (source, type, offer = 'discount') => {
    Amplitude.logEvent('Delete Offer Screen', {
        source,
        type,
        offer,
    });
};
export const logDeleteReviewsScreen = () => {
    const source = 'delete';
    Amplitude.logEvent('Delete Reviews Screen', {
        source,
    });
};
export const logDeleteBenefitsScreen = (source) => {
    Amplitude.logEvent('Delete Benefits Screen', {
        source,
    });
};
export const logDeleteLostBenefits = () => {
    const source = 'unsubscribe';
    Amplitude.logEvent('Delete Lost Benefits Screen', {
        source,
    });
};
export const logDeleteWhyShouldIPayToSave = () => {
    const source = 'unsubscribe';
    Amplitude.logEvent('Delete Pay Save Screen', {
        source,
    });
};
export const logDeleteSaveScreen = () => {
    const source = 'unsubscribe';
    Amplitude.logEvent('Delete Save Screen', {
        source,
    });
};
export const logDeleteMoneyBehindScreen = () => {
    const source = 'delete';
    Amplitude.logEvent('Delete Money Behind Screen', {
        source,
    });
};
export const logDeleteSavePotentialScreen = (source) => {
    Amplitude.logEvent('Delete Save Potential', {
        source,
    });
};
export const logDeleteFinancialSuccessScreen = () => {
    const source = 'delete';
    Amplitude.logEvent('Delete Financial Success Screen', {
        source,
    });
};
export const logTrialExtensionSuccess = (type) => {
    const source = 'unsubscribe';
    Amplitude.logEvent('Trial Extended', { source, type });
};
